import React, { Component } from "react";
import { connect } from 'react-redux';
import {Tabs, Tab, Spinner} from 'react-bootstrap';
import {InventoryUserMappedAction, TokenValidation} from '../Dashboard/UserActions';
import {WebFormTemplate, WebFormTemplateAdd, WebFormMappedTemplate, WebFormTemplateEdit, WebFormTemplateNames,
  WebFormTemplateMap, WebFormTemplateMapExistingCheck, WebFormTemplateMapExistingCheckSuccess, closeModalPopUp, resetMapCheck} from './WebFormAction';
import AssignForm from './AssignForm.js'
import FormList from './FormList.js'
import ListTemplate from './ListTemplate.js'
import ShowModalPopUp from '../ShowModalPopUp';
import _ from 'lodash';

class WebForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }  
  componentDidMount(){
    this.props.TokenValidation()  
    this.props.formNames()
    this.props.actioninventoryUserMapped()
  }
 
  loadTabContent = (prop) => {
    this.setState({key:prop})
  } 
  ScreensComp = () =>{        
    const{inventoryMapped, mapCheck, webFormNames, isExisting, webform, mappedTemplate, loginAction} = this.props;  
    const{key} = this.state
    if(!_.isEmpty(loginAction)){
    let moduleAccess = _.find(loginAction.modulescreens, {"moduleUId": "WEB_FORM"})
    let returnObj =[]
    _.map(moduleAccess.screens, (obj) =>{ 
        if(obj.screenUId === "ASSIGN_FORM"){ 
          returnObj.push(<Tab eventKey="ASSIGN_FORM" title="TEMPLATE MAPPING" key={2}>
             <AssignForm action={this.props} inventory={inventoryMapped} mapCheck={mapCheck}
                webFormNames={webFormNames} isExisting={isExisting}/>
         </Tab>)}
      //   if(obj.screenUId === "CREATE_NEW_FORM"){ 
      //     returnObj.push(<Tab eventKey="CREATE_NEW_FORM" title="NEW FORM" key={1}>
      //     <NewForm action={this.props} webFormNames={webFormNames} loginAction={loginAction}/>        
      //  </Tab>)}
				if(obj.screenUId === "LIST_WEB_FORMS"){ 
          returnObj.push(<Tab eventKey="LIST_WEB_FORMS" title="LIST WEB FORMS" key={1}>          
          <ListTemplate action={this.props} accessPermission={obj.accessPermission} webFormNames={webFormNames} loginAction={loginAction}
           webtemplates={webform} /> 
         </Tab>)}
        if(obj.screenUId === "MAPPED_FORMS"){ 
          returnObj.push(<Tab eventKey="MAPPED_FORMS" title="MAPPED FORMS" key={3}>          
          <FormList action={this.props} webFormNames={webFormNames} accessPermission={obj.accessPermission} loginAction={loginAction}
           webtemplates={webform} mappedTemplate={mappedTemplate} inventory={inventoryMapped}/> 
         </Tab>)}
    })
    returnObj =	_.sortBy(returnObj, ['key'])
   return (<Tabs defaultActiveKey={moduleAccess.screens[0].screenUId} transition={false} activeKey={key ? key : returnObj[0].props.eventKey} unmountOnExit={true}
   id="noanim-tab-example" onSelect={(eventKey)=>this.loadTabContent(eventKey)}>
   {returnObj}</Tabs>)
    }
     
  }  
  render() {
    let style= true
		if(typeof this.props.size !== 'undefined'){
			style = this.props.size
    }
    return (
     <div className={(style) ? 'user' : "userSmall"}>
       {(this.props.showerror === true) ?
        <ShowModalPopUp message={this.props.errmessage} 
        falseShowModalPopUp={this.props.closeModalPopUp}/> : null}
       {this.props.isPending ? <p className='spinner'><Spinner animation="grow" role="status" size='lg'/>
        Loading...</p> : null}
        {this.ScreensComp()}
        </div>
      );
  }
}
function mapStateToProps(state){
  return{
    inventoryMapped: state.UserReducer.inventoryMapped,
    webform : state.WebFormReducer.webform,
    mappedTemplate : state.WebFormReducer.mappedData,    
    webFormNames : state.WebFormReducer.formName, 
    isExisting : state.WebFormReducer.isExisting,      
    mapCheck : state.WebFormReducer.mapCheck,    
    size: state.UserReducer.large,
    showerror:  state.WebFormReducer.showerror, 
    isPending:  state.WebFormReducer.isPending, 
    errmessage:  state.WebFormReducer.errmessage,
    loginAction: state.LoginReducer.loginAction,
    showModalLogin: state.UserReducer.showModalLogin,
  }  
}

const mapDispatchToProps = (dispatch) => ({
  actioninventoryUserMapped:  () =>dispatch(InventoryUserMappedAction()),
  addTemplate: (a) =>dispatch(WebFormTemplateAdd(a)),
  editTemplate: (a) =>dispatch(WebFormTemplateEdit(a)),  
  mappedFormList: (a) =>dispatch(WebFormMappedTemplate(a)),
  unmappedFormList: () =>dispatch(WebFormTemplate()) , 
  formNames: () =>dispatch(WebFormTemplateNames()),
  mapTemplate: (a, b) =>dispatch(WebFormTemplateMap(a, b)),
  isExistingCheck: (a) =>dispatch(WebFormTemplateMapExistingCheck(a)),
  isExistingCheckSucess: (a) =>dispatch(WebFormTemplateMapExistingCheckSuccess(a)),
  closeModalPopUp:  (a) =>dispatch(closeModalPopUp(a)),
  resetMapCheck:  () =>dispatch(resetMapCheck()),
  TokenValidation : (a) => dispatch(TokenValidation(a))  
    
})

export default connect(mapStateToProps, mapDispatchToProps)(WebForm);
